export default "__VITE_ASSET__DqzOceDe__"